import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/vint50.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Catalogue", path: "/catalogue" },
    { name: "Careers", path: "/careers" },
  ];

  return (
    <nav
      className={`navbar navbar-expand-lg fixed-top ${scrolled ? "glass-panel" : ""}`}
      style={{
        padding: scrolled ? "15px 0" : "30px 0",
        backgroundColor: scrolled ? "rgba(15, 17, 21, 0.9)" : "transparent",
        transition: "all 0.4s ease",
        borderBottom: scrolled ? "1px solid var(--glass-border)" : "none",
      }}
    >
      <div className="container">
        <Link to="/" className="navbar-brand d-flex align-items-center gap-3">
          <img
            src={logo}
            alt="Vintage Dealership"
            style={{
              height: scrolled ? "40px" : "50px",
              transition: "all 0.3s ease",
              filter: "brightness(1.1)"
            }}
          />
          <div className="d-flex flex-column">
            <span
              style={{
                fontFamily: "var(--font-heading)",
                color: "#fff",
                fontSize: "1.2rem",
                letterSpacing: "1px",
                lineHeight: "1"
              }}
            >
              VINTAGE
            </span>
            <span
              style={{
                fontFamily: "var(--font-body)",
                color: "#ffffff",
                fontSize: "0.7rem",
                letterSpacing: "3px",
                textTransform: "uppercase",
                textShadow: "0 2px 4px rgba(0,0,0,0.8)"
              }}
            >
              DEALERSHIP
            </span>
          </div>
        </Link>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler border-0"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          style={{ color: "#fff" }}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Desktop Menu */}
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-center gap-4">
            {navLinks.map((link) => (
              <li key={link.name} className="nav-item">
                <Link
                  to={link.path}
                  className="nav-link position-relative"
                  onClick={() => setIsOpen(false)}
                  style={{
                    color: location.pathname === link.path ? "var(--highlight-gold)" : "#ffffff",
                    fontFamily: "var(--font-body)",
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    transition: "color 0.3s ease",
                    outline: "none",
                    boxShadow: "none",
                    textShadow: "0 2px 4px rgba(0,0,0,0.8)"
                  }}
                >
                  {link.name}
                  {location.pathname === link.path && (
                    <span
                      style={{
                        position: "absolute",
                        bottom: "-5px",
                        left: "0",
                        width: "100%",
                        height: "2px",
                        background: "var(--highlight-gold)"
                      }}
                    />
                  )}
                </Link>
              </li>
            ))}

          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
